import React, { useEffect, useRef, useState } from "react";
import {
    Container,
    Grid,
    TextField,
    Box,
    Button,
    Typography,
} from "@mui/material";

import { imagePath } from "../../../utils/assetUtils";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import StoreService from "../../Store/service/StoreService";
import Modal from "@mui/material/Modal";
import { useLocation } from "react-router-dom";
import { SnackbarAlert } from "../SnackbarAlert";
import SimpleReactValidator from "simple-react-validator";
import { useAppDispatch } from "../../../redux/hooks";
import { snackbarActions } from "../../../redux/features/snackbar/snackbarSlice";
import DemoUserService from "../../DemoUsers/service/demoUsersService";
import { useSearchParams } from "react-router-dom";
import { DEMO_USER_LIST_CONSTANTS } from "../../../constants/constants";

const InviteUserSeller = (props: any) => {
    const { showSnackbar, handleLoader, isDemoUser } = props;
    {
    /* Language translate function*/
    }
    const [t, i18n] = useTranslation();
    {
    /* Language translate function*/
    }

    const [searchParams] = useSearchParams();
    const demoStoreId = Number(searchParams.get("demoStoreId"));
    const isRevokeAndInvite = searchParams.get("isRevokeAndInvite") === "true";

    const dispatch = useAppDispatch();
    const [email, setEmail] = useState("");
    const [inviteResponseData, setInviteResponseData] = useState<{
        demoUserId: number;
        status: number;
        expirationDate: string;
        storeCode: string;
    } | null>(null);
    const error = "" ;

    const isExpired = (expirationDateString: string): boolean => {
        const formatted = expirationDateString.replace(/\//g, "-").replace(" ", "T");
        return new Date(formatted) < new Date();
    };
    const userType = parseInt(localStorage.getItem("userType") ?? "");

    // validation
    const [, forceUpdate] = useState(0);

    useEffect(() => {   
        dispatch(snackbarActions.HIDE_SNACKBAR(false));
    },[]);


    const validator = useRef(
        new SimpleReactValidator({
            autoForceUpdate: { forceUpdate },
            className: "text-danger",
            messages: {
                email: t("invitation_page.please_enter_valid_email"),
                max: t("invitation_page.max_80_char"),
                required: t("required.this_field_cannot_be_empty"),
            },
        })
    );

    useEffect(() => {
        forceUpdate(1);
    });

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        name === "email" ? setEmail(value) : null;

        validator.current.hideMessageFor(name);
    };

    const handleOnBlur = (e: any) => {
        const { name } = e.target;

        validator.current.showMessageFor(name);
    };


    const closeInviteWindow = () => {
        if (typeof (props?.close) === "function") {
            props.close();
        } else {
            window.close();
        }
    };

    const handleSubmit = async() => {
        if (validator.current.allValid()) {
            handleLoader(true);
            const isHitDummyURL = false;
            const payload = isDemoUser ? (isRevokeAndInvite ? {demoUserId: demoStoreId,revokeAndInvite: true,email: email }  : { email: email, demoStoreId: demoStoreId } ) : { email: email, userType: userType };
            try {
                const res = isDemoUser
                    ? (isRevokeAndInvite
                        ?await new DemoUserService(payload, isHitDummyURL).revokeUser()
                        : await new DemoUserService(payload, isHitDummyURL).inviteDemoUser())
                    : await new StoreService(payload, isHitDummyURL).inviteUser();

                if (isDemoUser && res?.data?.status !== undefined) {
                    if (isExpired(res.data.expirationDate)) {
                        setInviteResponseData(res.data);
                    } else {
                        showSnackbar(res.message, false);
                    }
                    return;
                }

                showSnackbar(res.message, true);
                if(isDemoUser){
                    const opener = window.opener as any | null;
                    if (opener && typeof opener.demoUserListApi === "function") {
                        const FirstPage = opener.demoUserFirstPage;
                        const limit = opener.demoUserLimit;
                        opener.demoUserListApi(FirstPage, limit);
                    }
                    setTimeout(() => {
                        closeInviteWindow();
                    }, 1000);
                }
                setTimeout(() => close(), 1000);
            } catch (err: any) {
                showSnackbar(err?.message, false);
            } finally {
                handleLoader(false);
            }
        } else {
            validator.current.showMessages();
        }
    };

    const handleResend = async () => {
        handleLoader(true);
        const isHitDummyURL = false;
        const payload = { demoUserId: inviteResponseData?.demoUserId, revokeAndInvite: true, email: email };
        try {
            const res = await new DemoUserService(payload, isHitDummyURL).revokeUser();
            showSnackbar(res.message, true);
            const opener = window.opener as any | null;
            if (opener && typeof opener.demoUserListApi === "function") {
                const FirstPage = opener.demoUserFirstPage;
                const limit = opener.demoUserLimit;
                opener.demoUserListApi(FirstPage, limit);
            }
            setTimeout(() => {
                closeInviteWindow();
            }, 1000);
        } catch (err: any) {
            showSnackbar(err?.message, false);
        } finally {
            handleLoader(false);
        }
    };

    const handleReturnToList = () => {
        closeInviteWindow();
    };
   


    return (
        <>
            <div className="main">
                {/* ForgotPassword page starts here */}
                
                <Container>
                    <Grid container>
                        {/* offset grid with column*/}
                        <Grid item xs={12} xl={4} lg={4} md={2} sm={12}></Grid>
                        {/* main grid column! */}
                        <Grid item xs={12} xl={4} lg={4} md={8} sm={12}>
                            <img className="logo-img" alt="cainz" src={imagePath("logo-large.png")}/>
                            <Grid sx={{ mb:2}}>
                                <TextField
                                    fullWidth
                                    type="email"
                                    value={email}
                                    name="email"
                                    label={t("invitation_page.email_address")}
                                    variant="outlined"
                                    onChange={handleChange}
                                    error={error ? true : false}
                                    helperText={error}
                                    onBlur={(e) => handleOnBlur(e)}
                                    disabled={!!inviteResponseData}
                                />
                                {!inviteResponseData && validator.current.message("email", email, [
                                    "required",
                                    { max: 80 },
                                    "email",
                                ])}
                                {inviteResponseData ? (
                                    inviteResponseData.status === DEMO_USER_LIST_CONSTANTS.STATUS_INVITED ? (
                                        <>
                                            <Typography sx={{ my: 2, textAlign: "left" }}>
                                                {t("invitation_page.already_invited_expired", { storeCode: inviteResponseData.storeCode })}
                                            </Typography>
                                            <Button fullWidth onClick={handleResend} sx={{ my: 2 }}>
                                                {t("invitation_page.re_send_invitation")}
                                            </Button>
                                        </>
                                    ) : (
                                        <>
                                            <Typography sx={{ my: 2, textAlign: "left" }}>
                                                {t("invitation_page.already_registered_expired", { storeCode: inviteResponseData.storeCode })}
                                            </Typography>
                                            <Button fullWidth onClick={handleReturnToList} sx={{ my: 2 }}>
                                                {t("invitation_page.return_to_demo_store_list")}
                                            </Button>
                                        </>
                                    )
                                ) : (
                                    <Button fullWidth onClick={handleSubmit} sx={{my:2}}>
                                        {t("invitation_page.invite")}
                                    </Button>
                                )}
                            </Grid>
                        </Grid>
                        {/* offset grid with column*/}
                        <Grid item xs={12} xl={4} lg={4} md={2} sm={12}></Grid>
                    </Grid>
                        
                </Container>
            </div>
        </>
    );
};

export default InviteUserSeller;
